import { useReactiveVar } from '@apollo/client'
import { PrivySignInButton } from 'features/auth-privy'
import { isUserAccessDeniedVar } from 'shared/store/user'
import { useReferralCodeFromUrl } from '../hooks/use-referral-code-from-url'

/** Header entry point for guests: the Privy sign-in (FE-302, FE-306). */
export const Auth = () => {
  useReferralCodeFromUrl()

  const isAuthAccessDenied = useReactiveVar(isUserAccessDeniedVar)

  /** NOTE: Access to authentication is restricted in some countries */
  if (isAuthAccessDenied) return null

  return <PrivySignInButton />
}
